import * as D from '../../../utils/dbmodel';

export default {
    namespaced: true,
    state: {
        list: [], //table中的list显示数据
        pagination: {

        }, //分页相关的信息
        record: {}, //根据id查询的数据详情信息
    },

    getters: {

    },

    mutations: {
        save(state, action) {

            for (var key in action.payload) {
                state[key] = action.payload[key]
            }
        }
    },

    actions: {

        //查询分支列表
        query(context, payload) {
            return D.select({
                ...payload
            })
        },
        //查询分支状态
        add(context, payload) {
            return D.add({
                ...payload
            })
        },

        edit(context, payload) {
            return D.edit({
                ...payload
            })
        },

        delete(context, payload) {
            return D.del({
                ...payload
            })
        },

        

    }
}
